
import NativeStorage from './NativeStorage.js';
import LocalStorage from './LocalStorage.js';

const API_URL = process.env.API_URL;

let cache = null;
if (process.env.CORDOVA) {
    cache = new NativeStorage();
    console.log('Setting native storage base URL', API_URL);
    if (window.NativeStorage) {
        window.NativeStorage.setItem('baseUrl', API_URL,
            function (ok) {
                console.log('NativeStorage set Ok');
            },
            function (error) {
                console.log('NativeStorage set Err', error);
            }
        );
    }
} else {
    cache = new LocalStorage();
}

export default cache;

export const keys = {
    'TOKEN_KEY': 'TOKEN',
    'USER_KEY': 'USER',
    'DEVICE_KEY': 'CURRENT_DEVICE',
    'COMPANY_KEY': 'COMPANY'
};



// WEBPACK FOOTER //
// ./src/services/cache/index.js